import { Link, useNavigate } from "react-router-dom";
import { BasketBoxComponent2 } from "./BasketBoxComponent";
import {
  CHANGE_PASSWORD_URL_LOCAL,
  HOME_URL_LOCAL,
  LOGIN_URL_LOCAL,
  PROFILE_URL_LOCAL,
  REGISTER_URL_LOCAL,
  SEARCH_PRODUCT_URL_LOCAL,
  SECTION_USER_URL_LOCAL,
  SHOPPINGCART_URL_LOCAL,
} from "../../../utility/BaseUrl";
import { handleLogout } from "../../../utility/PublicComponent";
import { useState } from "react";

export default function MenuMobileComponent({ fullName, cart, setData }) {
  const navigate = useNavigate();
  const [toggleModalBasket, setToggleModalBasket] = useState(false);
  const handelToggleModalBaket = () => {
    setToggleModalBasket(!toggleModalBasket);
  };

  return (
    <div className="d-md-none">
      <div className="mainmenu bg-white shadow py-1">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-3">
              <div className="text-center">
                <Link
                  to={HOME_URL_LOCAL}
                  className="mainmenu-item mainmenu-item-home"
                  title="صفحه نخست"
                >
                  <svg
                    width="1em"
                    height="1em"
                    viewBox="0 0 16 16"
                    className="mainmenu-item-icon"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M6.5 10.995V14.5a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .146-.354l6-6a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 .146.354v7a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5V11c0-.25-.25-.5-.5-.5H7c-.25 0-.5.25-.5.495z"></path>
                    <path
                      fillRule="evenodd"
                      d="M13 2.5V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
                    />
                  </svg>
                  <br />
                  خانه
                </Link>
              </div>
            </div>
            <div className="col-3">
              <div className="text-center">
                <a
                  className="mainmenu-item mainmenu-item-home"
                  title="سبد خرید"
                  onClick={handelToggleModalBaket}
                >
                  <svg
                    width="1em"
                    height="1em"
                    viewBox="0 0 16 16"
                    className="mainmenu-item-icon"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
                    ></path>
                  </svg>
                  {cart.items && cart.items.length > 0 ? (
                    <span className="mainmenu-item-basket-number">
                      {cart.items.length}
                    </span>
                  ) : null}
                  <br />
                  سبدخرید
                </a>
              </div>
            </div>
            <div className="col-3">
              <div className="text-center">
                <Link
                  to={SEARCH_PRODUCT_URL_LOCAL}
                  href="#"
                  className="mainmenu-item mainmenu-item-home"
                  title="جستجو"
                >
                  <svg
                    width="1em"
                    height="1em"
                    viewBox="0 0 16 16"
                    className="mainmenu-item-icon"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z"
                    ></path>
                    <path
                      fillRule="evenodd"
                      d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"
                    ></path>
                  </svg>
                  <br />
                  جستجو
                </Link>
              </div>
            </div>
            <div className="col-3">
              <div className="text-center">
                <div className="dropdown d-inline-block">
                  <a
                    href="#"
                    className="mainmenu-item mainmenu-item-user"
                    title="پنل کاربری"
                    data-toggle="dropdown"
                    role="button"
                    aria-expanded="false"
                  >
                    <svg
                      width="1em"
                      height="1em"
                      viewBox="0 0 16 16"
                      className="mainmenu-item-icon"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                      ></path>
                    </svg>
                    <br />
                    کاربری
                  </a>
                  {!fullName ? (
                    <div className="dropdown-menu">
                      <Link to={LOGIN_URL_LOCAL} className="dropdown-item">
                        ورود
                      </Link>
                      <Link to={REGISTER_URL_LOCAL} className="dropdown-item">
                        ثبت‌نام
                      </Link>
                    </div>
                  ) : (
                    <div className="dropdown-menu">
                      <h6 className="dropdown-header">خوش آمدید {fullName} </h6>
                      <Link
                        to={SECTION_USER_URL_LOCAL}
                        className="dropdown-item"
                      >
                        <i className="fa fa-fw ml-1 mt-1 fa-user"></i>
                        بخش کاربری
                      </Link>
                      <Link to={PROFILE_URL_LOCAL} className="dropdown-item">
                        <i className="fa fa-fw ml-1 mt-1 fa-pencil" />
                        ویرایش مشخصات
                      </Link>
                      <Link
                        to={CHANGE_PASSWORD_URL_LOCAL}
                        className="dropdown-item"
                      >
                        <i className="fa fa-fw ml-1 mt-1 fa-lock"></i>
                        تغییر رمز عبور
                      </Link>
                      <Link
                        onClick={() => handleLogout(navigate)}
                        className="dropdown-item"
                      >
                        <i className="fa fa-fw ml-1 mt-1 fa-power-off" />
                        خروج
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /mainMenu */}
      {/* basket offcanvas */}
      <div
        className="offcanvas1-basket-overlay"
        onClick={handelToggleModalBaket}
        style={toggleModalBasket ? { display: "block" } : { display: "none" }}
      />
      <div
        className={
          "offcanvas1-basket bg-white rounded shadow" +
          (toggleModalBasket ? " offcanvas1-basket-expanded" : "")
        }
      >
        <div className="offcanvas-header p-3">
          <span className="offcanvas-header-logo-link">سبد خرید</span>
          <button
            type="button"
            className="offcanvas-close"
            onClick={handelToggleModalBaket}
          >
            <i className="fa fa-times" style={{ color: "#000" }} />
          </button>
        </div>
        <div className="offcanvas1-basket-items">
          {cart.items && cart.items.length > 0 ? (
            <>
              {cart.items.map((item) => {
                return <BasketBoxComponent2 setData={setData} item={item} />;
              })}
              <div className="offcanvas1-basket-container">
                <Link
                  to={SHOPPINGCART_URL_LOCAL}
                  className="btn btn-block btn-primary offcanvas1-basket-link"
                  onClick={() => {
                    setToggleModalBasket(false);
                  }}
                >
                  ثبت و نهایی کردن سفارش
                  <i className="fa fa-chevron-left mr-half align-middle" />
                </Link>
              </div>
            </>
          ) : (
            <div className="offcanvas1-basket-empty text-center p-30">
              سبد خرید شما خالی است.
              <i className="fa fa-cube" />
            </div>
          )}
        </div>
      </div>
      {/* /basket offcanvas */}
      {/* search */}

      {/* /search */}
    </div>
  );
}
